import React from 'react'
import { Trans } from 'react-i18next'
import { Bb8, Bb9E, Bolt, Mini, Ollie, R2D2, R2Q5, RvR, Sphero } from './Components/Icons/Robots'
import SvgSprkPlus from './Components/Icons/Robots/SprkPlus'

export const FUSE_URL = 'https://fuse.littlebits.com/'
export const AUTH_TOKEN = 'auth-token'
export const SUCCESS = 'success'
// User Types
export const STUDENT = 'student'
export const TEACHER = 'teacher'
export const PARENT = 'parent'
// Class Types
export const FAST = 'Fast'
export const GOOGLE = 'Google'
export const STANDARD = 'Standard'
export const CLEVER = 'Clever'
// Registration Types
export const SPHEROCHANNEL = 'sphero'
export const GOOGLECHANNEL = 'google'
export const APPLECHANNEL = 'apple'
export const CLEVERCHANNEL = 'clever'
export const GOOGLE_CLASSROOM_CHANNEL = 'google classroom'
// Brands
export const SPHERO = 'Sphero'
export const LITTLE_BITS = 'littleBits'
export const INDIS = 'indi'
export const BLUEPRINTS = 'Blueprint'
export const SGC = 'Sgc'
// Program Types
export const BLOCK = 'block'
export const DRAW = 'draw'
export const TEXT = 'text'
// Bit types
export const POWER = 'power'
export const INPUT = 'input'
export const OUTPUT = 'output'
export const WIRE = 'wire'
// Card Types
export const PROGRAM = 'program'
export const ACTIVITY = 'activity'
export const ASSIGNMENT = 'assignment'
// Premium content status
export const SUBSCRIBED = 'subscribed'
export const LOCKED = 'locked'

// TODO: add them to env variables
export const scopes = [
  'https://www.googleapis.com/auth/classroom.courses.readonly',
  'https://www.googleapis.com/auth/classroom.rosters.readonly',
  'https://www.googleapis.com/auth/classroom.profile.emails',
  'https://www.googleapis.com/auth/userinfo.email',
  'https://www.googleapis.com/auth/userinfo.profile'
]

// Progress of assignments
export const STATUSES = {
  Progress: 'progress',
  Review: 'in_review',
  Complete: 'complete',
  Draft: 'draft',
  Published: 'published',
  Private: 'private',
  Public: 'public'
}

export const CLASS_TAG_KEYS = {
  HOME: 'tags.home',
  SCHOOL: 'tags.school',
  MATH: 'tags.math',
  SCIENCE: 'tags.science',
  COMSCI: 'tags.comsci',
  TECHNOLOGY: 'tags.technology',
  IT: 'tags.it',
  HISTORY: 'tags.history',
  SOCSCI: 'tags.socsci',
  LANG: 'tags.lang',
  FOREIGN: 'tags.foreign',
  LIT: 'tags.lit',
  MUSIC: 'tags.music',
  VISUAL_ARTS: 'tags.visual_arts',
  PERF_ARTS: 'tags.perf_arts',
  ART_HISTORY: 'tags.art_hist',
  HEALTH: 'tags.health',
  BUSINESS: 'tags.business',
  PHYS_ED: 'tags.phys_ed',
  HUMANITIES: 'tags.humanities',
  SEMSTER_SPRING: 'tags.semester.spring',
  SEMSTER_FALL: 'tags.semester.fall',
  SEMSTER_SUMMER: 'tags.semester.summer',
  QUARTER_SPRING: 'tags.quarter.sping',
  QUARTER_FALL: 'tags.quarter.fall',
  QUARTER_SUMMER: 'tags.quarter.summer',
  QUARTER_WINTER: 'tags.quarter.winter'
}

// Not order of robots is order we want them to display
export const ROBOTS = {
  BOLTPLUS: {
    type: 'Bolt+',
    name: 'Sphero BOLT+',
    id: 19,
    icon: (color, height, width) => {
      return <SvgSprkPlus color={color} style={{ height, width }} />
    },
    slug: 'bolt-plus'
  },
  BOLT: {
    type: 'Bolt',
    name: 'Sphero BOLT',
    id: 9,
    icon: (color, height, width) => {
      return <Bolt color={color} style={{ height, width }} />
    },
    slug: 'bolt'
  },
  RVR: {
    type: 'RVR/RVR+',
    name: 'Sphero RVR/RVR+',
    id: 18,
    icon: (color, height, width) => {
      return <RvR color={color} style={{ height, width }} />
    },
    slug: 'rvr'
  },
  MINI: {
    type: 'Sphero Mini',
    name: 'Sphero Mini',
    id: 7,
    icon: (color, height, width) => {
      return <Mini color={color} style={{ height, width }} />
    },
    slug: 'sphero-mini'
  },
  SPHERO: {
    type: 'Sphero',
    name: 'SPRK+\nSPRK/2.0',
    id: 2,
    icon: (color, height, width) => {
      return <Sphero color={color} style={{ height, width }} />
    },
    slug: 'sphero'
  },
  OLLIE: {
    type: 'Ollie',
    name: 'Ollie',
    id: 3,
    icon: (color, height, width) => {
      return <Ollie color={color} style={{ height, width }} />
    },
    slug: 'ollie'
  },
  BB8: {
    type: 'BB-8',
    name: 'BB-8',
    id: 4,
    icon: (color, height, width) => {
      return <Bb8 color={color} style={{ height, width }} />
    },
    slug: 'bb-8'
  },
  BB9E: {
    type: 'BB-9E',
    name: 'BB-9E',
    id: 5,
    icon: (color, height, width) => {
      return <Bb9E color={color} style={{ height, width }} />
    },
    slug: 'bb-9e'
  },
  R2D2: {
    type: 'R2-D2',
    name: 'R2-D2',
    id: 6,
    icon: (color, height, width) => {
      return <R2D2 color={color} style={{ height, width }} />
    },
    slug: 'r2-d2'
  },
  R2Q5: {
    type: 'R2-Q5',
    name: 'R2-Q5',
    id: 8,
    icon: (color, height, width) => {
      return <R2Q5 color={color} style={{ height, width }} />
    },
    slug: 'r2-q5'
  }
}

export const SORT_OPTION = [
  {
    key: 'newest',
    text: <Trans i18nKey='filter.sortby.newest'>New to Old</Trans>,
    value: 'newest'
  },
  {
    key: 'oldest',
    text: <Trans i18nKey='filter.sort_by.oldest' />,
    value: 'oldest'
  }
]

export const PROGRAM_TYPE_OPTION = [
  {
    key: 'all',
    text: <Trans i18nKey='filter.type.all'>All</Trans>,
    value: 'all'
  },
  {
    key: 'draw',
    text: <Trans i18nKey='filter.type.draw'>Draw</Trans>,
    value: 'draw'
  },
  {
    key: 'blocks',
    text: <Trans i18nKey='filter.type.blocks'>Block</Trans>,
    value: 'block'
  },
  {
    key: 'texts',
    text: <Trans i18nKey='filter.types.texts'>Text</Trans>,
    value: 'text'
  }
]

export const SORT_BY = [
  {
    key: 'newest',
    text: <Trans i18nKey='filter.sort_by.newest' />,
    value: 'recent_change'
  },
  {
    key: 'oldest',
    text: <Trans i18nKey='filter.sort_by.oldest' />,
    value: 'oldest_change'
  }
]

export const NAV_BAR_HEIGHT = 80
export const FOOTER_HEIGHT = 320
// TODO this link is to old platform, when we have better links for production/staging etc for new platform change out to that
export const defaultImageLink = ['rc-edu.sphero.com', 'edu.sphero.com'].includes(window.location.hostname) ? 'https://sphero-media-sphero-prod.s3.amazonaws.com/cwist/default_previews/default_program_300_300.png' : 'https://sphero-media-sphero-stg.s3.amazonaws.com/cwist/default_previews/default_program_300_300.png'

export const baseLink = ['rc-edu.sphero.com', 'edu.sphero.com'].includes(window.location.hostname) ? 'https://sphero-media-sphero-prod.s3.amazonaws.com/' : 'https://sphero-media-sphero-stg.s3.amazonaws.com/'

export const VIEWTYPE = {
  NO_SPLIT_SCREEN: 'no-split-screen',
  ACTIVITY_ONLY: 'activity-only',
  PROGRAM_ONLY: 'program-only',
  SPLIT_VIEW: 'split-view'
}

export const SIGN_IN_STATE = {
  KIOSK: 'kiosk',
  HOME_AUTH: 'homeAuth',
  SCHOOL_AUTH: 'schoolAuth',
  SCHOOL_CHOOSE_ROLE: 'schoolChoseRole',
  HOME_CHOOSE_ROLE: 'homeChooseRole',
  CHOOSE_ROLE: 'chooseRole',
  SIGN_UP: 'signUp',
  AGE_GATE: 'ageGate',
  STUDENT_SIGN_IN: 'studentSignIn',
  YOUNG_LEARNER: 'youngLearner',
  CLASS_CODE_AUTH: 'classCodeAuth',
  VERIFY_EMAIL: 'verifyEmail',
  SSO_CHOOSE_ROLE: 'ssoChooseRole',
  MISSING_INFO: 'missingInfo',
  CLEVER: 'users/auth/clever/callback',
  MISSING_ROLE: 'missingRole',
  EXPIRED: 'expired'
}

export const GOOGLE_SYNC_STATE = {
  FINISH: 'finished',
  PROGRESS: 'in-progress',
  ERROR: 'error',
  REFRESH: 'refresh'
}

export const ASSESSMENT_OPTIONS = [
  { text: <Trans i18nKey='step.type.label.checkbox'>Checkbox</Trans>, key: 'single-choice', value: 'C' },
  { text: <Trans i18nKey='steps.assessment.multiple_choice_question'>Multiple Choice</Trans>, key: 'Multiple Choice', value: 'M' },
  { text: <Trans i18nKey='steps.assessment.fill_in_blank'>Fill In the Blank</Trans>, key: 'text', value: 'T' },
  { text: <Trans i18nKey='steps.assessment.image'>Image</Trans>, key: 'image', value: 'P' }
]

export const timeOptions = [
  {
    key: 'duration.tag.up_to_1',
    value: 'Up to 1 hour',
    text: <Trans i18nKey='duration.tag.up_to_1'>Up to 1 hour</Trans>
  },
  {
    key: 'duration.tag.1to2',
    value: '1-2 hours',
    text: <Trans i18nKey='duration.tag.1to2'>1-2 hours</Trans>
  },
  {
    key: 'duration.tag.2to4',
    value: '2-4 hours',
    text: <Trans i18nKey='duration.tag.2to4'>2-4 hours</Trans>
  },
  {
    key: 'duration.tag.4to6',
    value: '4-6 hours',
    text: <Trans i18nKey='duration.tag.4to6'>4-6 hours</Trans>
  },
  {
    key: 'duration.tag.6to8',
    value: '6-8 hours',
    text: <Trans i18nKey='duration.tag.6to8'>6-8 hours</Trans>
  },
  {
    key: 'duration.tag.multiday',
    value: 'Multi-Day',
    text: <Trans i18nKey='duration.tag.multiday'>Multi-Day</Trans>
  }
]

// eslint-disable-next-line no-unused-vars
export const LanguageCodes = {
  'English (United States)': 'en-us',
  Czech: 'cs',
  Danish: 'da',
  Dutch: 'nl',
  'English (Australia)': 'en-au',
  'English (Ireland)': 'en-ie',
  'English (United Kingdom)': 'en-gb',
  Finnish: 'fi',
  French: 'fr',
  German: 'de',
  Greek: 'el',
  Italian: 'it',
  Norwegian: 'no',
  Portuguese: 'pt-pt',
  Slovak: 'sk',
  Spanish: 'es',
  Swedish: 'sv'
}

export const FlagCodes = {
  'English (United States)': 'us',
  'English (Australia)': 'au',
  Danish: 'dk',
  Dutch: 'nl',
  'English (Ireland)': 'ie',
  'English (United Kingdom)': 'uk',
  Finnish: 'fi',
  French: 'fr',
  German: 'de',
  Italian: 'it',
  Norwegian: 'no',
  Portuguese: 'pt',
  Spanish: 'es',
  Swedish: 'se',
  Czech: 'cz',
  Slovak: 'sk',
  Greek: 'gr'
}

export const CategoryColors = {
  INPUT: '#C21570',
  OUTPUT: '#78AE05',
  WIRE: '#EB7C17',
  POWER: '#0033A1'
}
